"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Control = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var Control = exports.Control = function Control(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Control, props, children);
};